module.exports = __webpack_public_path__ + "img/about-sponsor-2@2x.5170c1ec.png";